<div class="arrowBtn d-none d-xxl-inline">
  <a (click)="goBack()" class="btn btn-outline-dark">
    <i class="bi bi-arrow-left arrowIcon"></i>
  </a>
</div>

<div class="container-fluid ps-3 pe-3 ps-lg-3 pe-lg-3 ps-xl-4 pe-xl-4 ps-xxl-5 pe-xxl-5"
  style="background-color: white; min-height: 72vh; min-width: 350px; max-width: 1500px;">

  <!-- FIRST CARD -->
  <div class="row justify-content-center mb-5" style="position: sticky; top: 40px; z-index: 100;">
    <div class="col-12 mt-4 ps-0 pe-0 ps-md-1 pe-md-1 card-width">
      <mat-expansion-panel style="z-index: 101;" class="customPanel ticketPanel" #panel expanded appInViewport>
        <mat-expansion-panel-header class="cutomPanelHeader" style="background-color:#fcf3cf">
          <mat-panel-title style="justify-content: start;">
            <span style="font-size: x-large; font-weight: bold;">
              {{"TICKET.MODIFY.TICKETID" | translate}}: {{idticket}}
            </span>
          </mat-panel-title>
          <span *ngIf="!isSmallScreen; else screenStatusBlock" class="me-4" style="display: flex; align-items: center;">
            {{"TICKET.MODIFY.STATUS" | translate}}:
            <i class="bi bi-circle-fill ms-2 me-1" [ngStyle]="{'color': ticketInfo?.ticketStatus?.color}"></i>
            {{ticketInfo?.ticketStatus?.name_status}}
          </span>
          <ng-template #screenStatusBlock>
            <span class="me-3" style="display: flex; align-items: center;">
              <i class="bi bi-circle-fill ms-2 me-1" [ngStyle]="{'color': ticketInfo?.ticketStatus?.color}"></i>
            </span>
          </ng-template>
        </mat-expansion-panel-header>

        <div class="row justify-content-center mt-2">
          <div class="col-12 col-lg-6 col-xl-12 mt-2">
            <span class="ticketInfoTitle">
              {{"TICKET.MODIFY.SYSTEMINFO" | translate}}:
            </span>
            <span class="ms-1 truncate-text">
              {{ticketInfo?.system_name}}
            </span>
            <button class="btn btn-sm btn-outline-dark ms-2" (click)="systemInfoPopup()">
              <i class="bi bi-card-text"></i>
            </button>
          </div>

          <div class="col-6 col-xl-4 text-lg-end text-xl-start mt-2">
            <span class="ticketInfoTitle">
              {{"TICKET.MODIFY.PROGRESSIVE" | translate}}:
            </span><br *ngIf="isSmallScreen">
            <span class="ticketInfoContent">
              {{ticketInfo?.progressive}}/
              {{ticketInfo?.ticket_date}}
            </span>
          </div>

          <div class="col-6 col-xl-4 text-lg-start text-xl-center mt-2">
            <span class="ticketInfoTitle">
              {{"TICKET.MODIFY.OPENEDFROM" | translate}}:
            </span><br *ngIf="isSmallScreen">
            <span class="ticketInfoContent">
              {{ticketInfo?.user_created?.nickname}}
            </span>
          </div>

          <div class="col-12 col-lg-6 col-xl-4 text-lg-end mt-2">
            <span class="ticketInfoTitle">
              {{"TICKET.MODIFY.ANSWEREMAIL" | translate}}:
            </span><br *ngIf="isSmallScreen">
            <span class="ticketInfoContent">
              {{ticketInfo?.email}}
            </span>
          </div>
        </div>

        <div class="row justify-content-center mt-2">
          <div class="col-12 text-center">
            <span class="ticketInfoTitle" style="border-bottom: 1px solid lightgray;">
              {{"TICKET.MODIFY.ANOMALYFOUNDED" | translate}}
            </span>
          </div>

          <!-- INVERTER LIST -->
          <div class="col-12 text-center col-md-6 mt-3 mb-2 ps-md-3 ps-lg-5 pe-md-3 pe-lg-5"
            [ngStyle]="{'border-right': isSmallScreen ? 'none' : '1px solid lightgray'}">
            <span style="font-weight: 600; border-bottom: 1px solid lightgray;">
              {{"TICKET.MODIFY.INVERTERLIST" | translate}}
            </span>
            <div
              *ngIf="ticketInfo?.inverterList != null && ticketInfo?.inverterList?.length! > 0; else emptyInverterBlock"
              class="row justify-content-start align-items-group mt-2" style="border-bottom: 1px solid lightgray;">

              <div class="col-auto ps-0" *ngFor="let inverter of ticketInfo?.inverterList; let i = index">
                <span class="">
                  {{inverter.sn}}
                  <ng-container *ngIf="ticketInfo?.inverterList?.length! > i+1">
                    ,
                  </ng-container>
                </span>
              </div>
            </div>
            <ng-template #emptyInverterBlock>
              <div class="row justify-content-start align-items-group mt-2">
                <div class="col-12 text-center">
                  <span style="color: gray; font-style: italic;">
                    {{"TICKET.MODIFY.NOINVERTERS" | translate}}
                  </span>
                </div>
              </div>
            </ng-template>
          </div>

          <!-- BATTERY LIST -->
          <div class="col-12 text-center col-md-6 mt-3 mb-2 ps-md-3 ps-lg-5 pe-md-3 pe-lg-5"
            [ngStyle]="{'border-left': isSmallScreen ? 'none' : '1px solid lightgray'}">
            <span style="font-weight: 600; border-bottom: 1px solid lightgray;">
              {{"TICKET.MODIFY.BATTERYLIST" | translate}}
            </span>
            <div *ngIf="ticketInfo?.batteryList != null && ticketInfo?.batteryList?.length! > 0; else emptyBatteryBlock"
              class="row justify-content-start align-items-group mt-2" style="border-bottom: 1px solid lightgray;">

              <div class="col-auto ps-0" *ngFor="let battery of ticketInfo?.batteryList; let i = index">
                <span class="">
                  {{battery.sn}}
                  <ng-container *ngIf="ticketInfo?.batteryList?.length! > i+1">
                    ,
                  </ng-container>
                </span>
              </div>
            </div>
            <ng-template #emptyBatteryBlock>
              <div class="row justify-content-start align-items-group mt-2">
                <div class="col-12 text-center">
                  <span style="color: gray; font-style: italic;">
                    {{"TICKET.MODIFY.NOBATTERIES" | translate}}
                  </span>
                </div>
              </div>
            </ng-template>
          </div>
        </div>

        <div class="row justify-content-center mt-2">
          <div class="col-12">
            <span style="font-weight: bold; font-size: medium;">
              {{"TICKET.MODIFY.PROBLEMDESCRIPTION" | translate}}
            </span>
          </div>
          <div class="col-12">
            <!-- <quill-editor >
                            <div quill-editor-toolbar class="d-none"></div>
                            <span ql-editor>
                                {{ticketInfo?.description}}
                            </span> -->
            <div class="ql-editor p-0">
              <div class="content-wrapper p-3" style="border: 1px solid lightgray; border-radius: 10px; width: 100%;"
                [innerHTML]="getSanitizedDescription(ticketInfo?.description || '')">
              </div>
            </div>
            <!-- </quill-editor> -->
          </div>

          <div *ngFor="let img of ticketInfo?.attachments" class="col-auto mt-2">
            <img class="imgThumb" [src]="urlServerLaraMedia+img.src" (click)="viewImage(img)" [title]="img.title"
            onerror="this.onerror=null; this.src='assets/img/thumbImg.svg';">
          </div>
        </div>
      </mat-expansion-panel>
    </div>
  </div>

  <ng-container *ngFor="let message of messagesList; let i = index">
    <div class="row ps-3 pe-3 ps-lg-3 pe-lg-3 ps-xxl-5 pe-xxl-5"
      [ngClass]="{'marginBottom': (messagesList.length == i+1) && !isNewMessage}">
      <!-- TIMELINE -->
      <div class="col-1 d-none d-lg-inline ps-0 pe-0"
        style="border-right: 4px solid #002D5D; position: relative; max-width: 94px;">
        <span class="text-center"
          style="position: absolute; top: 48%; right: 20px; font-size: small; font-weight: 700; color: #002D5D;">
          {{message.date_only}} <br> {{message.time_only}}
        </span>
        <span style="position: absolute; top: 50%; right: -10px;">
          <i class="bi bi-circle-fill" style="color: #002D5D;"></i>
        </span>
      </div>

      <!-- CUSTOMER -->
      <div class="col-12 col-lg-11">
        <div *ngIf="message.portal == 1" class="row justify-content-end">
          <div class="col-11 col-md-10 mt-4 cardElement customPanel ticketPanel"
            style="max-width: 1200px; background-color: #fcf3cf;" appInViewport>
            <div class="row justify-content-center">
              <div class="col-6 text-start">
                <img src="assets/img/profileThumb.jpg" class="profile-image">
                <span *ngIf="!isSmallScreen" class="ms-2 panelTitle">
                  {{message.user_created.nickname}}
                </span>
              </div>
              <div class="col-6 text-end">
                <span style="color: gray; font-style: italic;"
                  [ngStyle]="{'font-size': isSmallScreen ? 'x-small' : 'small' }">
                  {{message.user_created.datetime}}
                </span>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-12 mt-2">
                <span class="form-label" style="border-bottom: 1px solid lightgray;">
                  {{"TICKET.MODIFY.MESSAGE" | translate}}
                </span><br>
                <div class="ql-editor">
                  <div [innerHTML]="getSanitizedDescription(message.description || '')">
                  </div>
                </div>
              </div>
            </div>

            <div class="row justify-content-center mt-2">
              <div *ngFor="let file of message.attachments" class="col-auto">
                <img class="imgThumb" [src]="urlServerLaraMedia+file.src" [title]="file.title"
                  (click)="viewImage(file)" onerror="this.onerror=null; this.src='assets/img/thumbImg.svg';">
              </div>
            </div>
          </div>
        </div>

        <!-- WECO TECHNICIAN -->
        <div *ngIf="message.portal == 0" class="row ps-lg-3 justify-content-start">
          <div class="col-11 col-md-10 mt-4 cardElement customPanel ticketPanel"
            style="max-width: 1200px; background-color: #edf5fe" appInViewport>
            <div class="row justify-content-center">
              <div class="col-6 text-start">
                <img src="assets/img/wecoW.jpg" class="profile-image">
                <span *ngIf="!isSmallScreen" class="panelTitle">
                  {{"TICKET.MODIFY.WECOTECHNICIAN" | translate}}
                </span>
              </div>
              <div class="col-6 text-end">
                <span style="color: gray; font-style: italic;"
                  [ngStyle]="{'font-size': isSmallScreen ? 'x-small' : 'small' }">
                  {{message.user_created.datetime}}
                </span>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-12 mt-2">
                <span class="form-label" style="border-bottom: 1px solid lightgray;">
                  {{"TICKET.MODIFY.MESSAGE" | translate}}
                </span><br>
                <div class="ql-editor">
                  <div [innerHTML]="getSanitizedDescription(message.description || '')">
                  </div>
                </div>
              </div>
            </div>

            <div class="row justify-content-center mt-2">
              <div *ngFor="let file of message.attachments" class="col-auto">
                <img class="imgThumb" (click)="viewImage(file)" [src]="urlServerLaraMedia+file.src"
                [title]="file.title" onerror="this.onerror=null; this.src='assets/img/thumbImg.svg';">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- NUOVO MESSAGGIO -->
  <div [formGroup]="newMessageForm" *ngIf="isNewMessage" class="row ps-3 pe-3 ps-lg-3 pe-lg-3 ps-xxl-5 pe-xxl-5">
    <!-- TIMELINE -->
    <div class="col-1 d-none d-lg-inline ps-0 pe-0"
      style="border-right: 4px solid #002D5D; position: relative; max-width: 94px;">
      <span class="text-center"
        style="position: absolute; top: 48%; right: 20px; font-size: small; font-weight: 700; color: #002D5D;">
        {{newMessageForm.get('date')?.value}} <br> {{newMessageForm.get('time')?.value}}
      </span>
      <span style="position: absolute; top: 50%; right: -10px;">
        <i class="bi bi-circle-fill" style="color: #002D5D;"></i>
      </span>
    </div>

    <div class="col-12 col-lg-11">
      <!-- NUOVO MESSAGGIO -->
      <div class="row justify-content-end">
        <div class="col-11 col-md-10 mt-4 cardElement customPanel ticketPanel"
          style="max-width: 1200px; background-color: #fcf3cf;" appInViewport>
          <div class="row justify-content-center">
            <div class="col-6 text-start">
              <img src="assets/img/profileThumb.jpg" class="profile-image">
              <span *ngIf="!isSmallScreen" class="ms-2 panelTitle">
                Nickname
              </span>
            </div>
            <div class="col-6 text-end">
              <span style="color: gray; font-style: italic;"
                [ngStyle]="{'font-size': isSmallScreen ? 'x-small' : 'small' }">
                {{newMessageForm.get('date')?.value}} / {{newMessageForm.get('time')?.value}}
              </span>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-12 mt-2 quillContainer"
              [ngClass]="{ 'is-invalid': newMessageForm.get('description')?.invalid && submitted }">
              <quill-editor formControlName="description" id="description"
                [class.is-invalid]="newMessageForm.get('description')?.invalid && submitted">
                <div above-quill-editor-toolbar>
                  <span class="form-label" for="description">
                    {{"TICKET.NEW.PROBLEMDESCRIPTION" | translate}}
                  </span>
                </div>
                <div quill-editor-toolbar style="background-color: white;">
                  <span class="ql-formats">
                    <button class="ql-bold" title="Bold"></button>
                    <button class="ql-italic" title="Italic"></button>
                    <button class="ql-underline" title="Underline"></button>
                    <button class="ql-strike" title="Strikethrough"></button>
                  </span>

                  <span class="ql-formats">
                    <select class="ql-font" title="Font Style">
                      <option selected></option>
                      <option value="serif"></option>
                      <option value="monospace"></option>
                    </select>
                    <select class="ql-size" title="Font Size">
                      <option value="small"></option>
                      <option selected></option>
                      <option value="large"></option>
                      <option value="huge"></option>
                    </select>
                  </span>

                  <span class="ql-formats">
                    <button class="ql-list" value="ordered" title="Ordered List"></button>
                    <button class="ql-list" value="bullet" title="Bullet List"></button>
                    <button class="ql-indent" value="-1" title="Decrease Indent"></button>
                    <button class="ql-indent" value="+1" title="Increase Indent"></button>
                  </span>

                  <span class="ql-formats">
                    <select class="ql-align" title="Align">
                      <option selected></option>
                      <option value="center"></option>
                      <option value="right"></option>
                      <option value="justify"></option>
                    </select>
                  </span>

                  <span class="ql-formats">
                    <select class="ql-color" title="Text Color"></select>
                  </span>
                </div>
              </quill-editor>
            </div>

            <div class="col-12 text-center mt-1">
              <span style="font-size: small; color: gray; font-style: italic;">
                {{"TICKET.MODIFY.MAXTHREE" | translate}}
              </span>
            </div>

            <div class="col-12 mt-1">
              <div class="row justify-content-center">
                <div *ngFor="let img of imagesList; let i = index" class="col-auto" style="position: relative;">
                  <img style="height: 50px; width: 40px; border: 1px solid lightgray; object-fit: cover;"
                    [src]="img.src" [title]="img.title" class="imgThumb" onerror="this.onerror=null; this.src='assets/img/thumbImg.svg';">
                  <button class="btn btn-danger p-0 btnZoom" style="position: absolute; right: 8px; top: -4px"
                    (click)="deleteFile(i)">
                    <i class="bi bi-x"></i>
                  </button>
                </div>

                <div class="col-auto">
                  <label *ngIf="fileList.length < maxImages" for="fileUpload2" class="btn btn-outline-dark mt-1">
                    <i class="bi bi-paperclip"></i>
                    <input type="file" id="fileUpload2" style="display: none;" (change)="onFileSelected($event)"
                      multiple>
                  </label>
                </div>
              </div>
            </div>

            <div *ngIf="newMessageForm.invalid && submitted" class="col-12 text-center mt-2">
              <span style="font-size: small; color: red;">
                {{"TICKET.MODIFY.MANDATORYFIELD" | translate}}
              </span>
            </div>
          </div>

          <div class="row justify-content-end pt-2 mt-2" style="border-top: 1px solid lightgray;">
            <div class="col-auto">
              <button class="btn btn-outline-dark" (click)="sendMessage()">
                {{"TICKET.MODIFY.SEND" | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <button *ngIf="!isNewMessage" class="btn btn-dark btnSticky" (click)="newMessage()">
    <i class="bi bi-chat-right-text me-2"></i>
    {{"TICKET.MODIFY.ADDMESSAGE" | translate}}
  </button>

  <div #bottomAnchor></div>
</div>
